import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { IListType } from "../store";
import siteDataaccess from "src/dataAccess/sites/siteDataaccess";

export const getSiteListSuccess = createAction<any>(
  "[Site] Get Site List Success"
);
export const loadingList = createAction<boolean>("[Site] Loading list");
export const AddSiteSupplier = createAction<any>("[Site] Add Suppliers");
export const SetSiteSupplier = createAction<any>("[Site] Set Suppliers");
export const SetSiteCategory = createAction<any>("[Site] Set category");
export const SetSiteCertification = createAction<any>(
  "[Site] Set Site Certification"
);
export const AddSiteCertification = createAction<any>(
  "[Site] Add Site Certification"
);

export const RemoveSiteSupplier = createAction<any>(
  "Remove Post Audit Event Success"
);
export const getSiteListAsync = createAsyncThunk<any, IListType>(
  "[Site] Get Site List",
  async (parameter, thunkAPI) => {
    console.log(parameter);
    thunkAPI.dispatch(loadingList(true));
    const result = await siteDataaccess.getListasync(parameter).then((res) => {
      thunkAPI.dispatch(getSiteListSuccess(res));
      thunkAPI.dispatch(loadingList(false));
      return res;
    });
    return result;
  }
);
export const getUpcomingAuditListAsyncSuccess = createAction<any>(
  "[Site] Get Upcoming Audit List Success"
);
export const getUpcomingAuditListAsync = createAsyncThunk<any, IListType>(
  "[Site] Get Upcoming Audit List",
  async (parameter, thunkAPI) => {
    console.log(parameter);
    thunkAPI.dispatch(loadingList(true));
    const result = await siteDataaccess
      .getUpcomingAuditListAsync(parameter)
      .then((res) => {
        thunkAPI.dispatch(getUpcomingAuditListAsyncSuccess(res));
        thunkAPI.dispatch(loadingList(false));
        return res;
      });
    return result;
  }
);
export const getOverdueAuditListAsyncSuccess = createAction<any>(
  "[Site] Get Overdue Audit List Success"
);
export const getOverdueAuditListAsync = createAsyncThunk<any, IListType>(
  "[Site] Get Overdue Audit List",
  async (parameter, thunkAPI) => {
    console.log(parameter);
    thunkAPI.dispatch(loadingList(true));
    const result = await siteDataaccess
      .getOverdueAuditListAsync(parameter)
      .then((res) => {
        thunkAPI.dispatch(getOverdueAuditListAsyncSuccess(res));
        thunkAPI.dispatch(loadingList(false));
        return res;
      });
    return result;
  }
);
